<div class="cookie-info" [hidden] = "!show">
	<div>{{'BANDEAU_COOKIES.TEXT' | translate}}<br/><span class="legal" (click)="goToLegal()">{{'BANDEAU_COOKIES.LINK_TEXT' | translate}}</span>
	</div>
	<button ion-button class="createuser" (click)="cookieAccepted()">{{'BANDEAU_COOKIES.BUTTON' | translate}}</button>
</div>
